import React, {Component} from "react";
import Radio from "./Radio";
import {durationToString} from "../../../../services/DurationUtil";
import SAInfoBubble from "../../../../components/common/confirmation/SAInfoBubble";
import {SelectedService} from "../../definition/journeyModel";
import {isoDurationToMinutes} from "../../definition/helper";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import PriceTag from '../../../../components/common/pricetag/PriceTag';

class RadioServiceItem extends Component {



  onCheckboxChange = (checked, item)=> {

    //const options = selectedOptions;
    //const index = options.findIndex(o => o.id === item.optionId);
    if (checked === true) {// unchecking the checkbox
      this.props.setTireService({
        selectedService:new SelectedService(
          item.name,
          item.title,
          isoDurationToMinutes(item.duration), //
          item.duration,
          item.price,
          item.description,
          item.moreInfo)
      });
    }
  }

  hasOption = name => !!this.props.selectedOptions.find(o => o.id === name);

  render(){
    const {item, radioGroup} = this.props;

    return <React.Fragment>
      <Radio
        name={radioGroup}
        id={item.name}
        onChange={checked=>this.onCheckboxChange(checked, item)}
        checked={this.hasOption(item.name)}
      />
      <label htmlFor={item.name} style={{width:'100%'}}>
        <span>{item.title}</span>
        <span style={{float:'right'}}>
          <PriceTag price={item.price}/>&nbsp;{item.duration ? `${durationToString(item.duration)}` : ''}{' '}
          {item.moreInfo && <SAInfoBubble content={item.moreInfo}/>}
        </span>
        <div style={{paddingLeft:'3rem',color:'#8e8e8e'}}>{item.description}</div>
      </label>

    </React.Fragment>

  }
}

const mapDispatchToProps = dispatch => ({
  setTireService: params => dispatch({ type: 'SAVE.SET_SERVICE', params }),

});

const mapStateToProps = state => ({
  selectedOptions: state.createAppointmentRequest.selectedOptions,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RadioServiceItem)
);



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/services/RadioServiceItem.js